(function () {
  var loaded = false;

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadSearchScripts() {
    if (loaded) return Promise.resolve();
    loaded = true;
    var assets = window.__eckoLazyAssets || {};
    var jobs = [];
    if (assets.detailsModal) jobs.push(loadScript(assets.detailsModal));
    if (assets.searchForm) jobs.push(loadScript(assets.searchForm));
    return Promise.all(jobs);
  }

  function bindTriggers() {
    var triggers = document.querySelectorAll(
      '.header__search summary, .header__icon--search, .header__search .header__icon'
    );
    triggers.forEach(function (el) {
      el.addEventListener('pointerdown', loadSearchScripts, { once: true });
      el.addEventListener('focus', loadSearchScripts, { once: true });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadSearchScripts, { timeout: 12000 });
    } else {
      setTimeout(loadSearchScripts, 12000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }
})();
